import { useDispatch } from 'react-redux';
import ios from './ios.svg';
import googlePlay from './google-play.svg';
import FontAwesomeIcon from '../Icon';
import { exitPropertyWalkThroughForm } from 'src/store/actions/propertyWalkThroughForm';
import { exitEasyWalkThroughForm } from 'src/store/actions/easyWalkThroughForm';
import './MobileAppCallToAction.scss';

interface MobileAppContentProps {
  header?: string;
  description?: string;
  className?: string;
}

export const MobileAppContent = ({
  header = 'Download the mobile app',
  description = 'Download the mobile app to log deficiencies, and complete walkthroughs on the go.',
  className = '',
}: MobileAppContentProps) => {
  return (
    <div className={`mobile-app-content-container ${className}`}>
      <h1 className="mobile-app-content-header">{header}</h1>
      <p className="mobile-app-content-description">{description}</p>
      <div className="mobile-app-content-store-buttons">
        <a
          className="mobile-app-content-store-link"
          href="https://apps.apple.com/ca/app/home-inspector-by-juniper/id6443896745"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            className="mobile-app-content-store-badge"
            src={ios}
            alt="Download on iOS"
          />
        </a>
        <a
          className="mobile-app-content-store-link"
          href="https://play.google.com/store/apps/details?id=com.juniper&hl=en_CA"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            className="mobile-app-content-store-badge mobile-app-content-google-play-badge"
            src={googlePlay}
            alt="Download on Google Play"
          />
        </a>
      </div>
      <a
        className="mobile-app-content-learn-more-link"
        href="https://knowledge.spark.re/juniper-home-inspector-app"
        target="_blank"
        rel="noopener noreferrer"
      >
        Learn More
      </a>
    </div>
  );
};

interface IMobileAppCallToActionProps {
  header?: string;
}

export const MobileAppCallToAction = ({
  header = 'Download the mobile app',
}: IMobileAppCallToActionProps) => {
  const dispatch = useDispatch();

  const goBack = () => {
    // this is legacy code, will need to be updated as part of
    // https://app.asana.com/0/1208712340140532/1209803742326178/f
    dispatch(exitPropertyWalkThroughForm());
    dispatch(exitEasyWalkThroughForm());
  };

  return (
    <div className="mobile-app-call-to-action-container">
      <div
        className="mobile-app-call-to-action-back-button"
        onClick={() => goBack()}
      >
        <FontAwesomeIcon glyph="arrow-left" weight="solid" size="medium" />
      </div>
      <div className="mobile-app-call-to-action-content-wrapper">
        <div className="mobile-app-call-to-action-content-panel">
          <MobileAppContent header={header} />
        </div>
      </div>
    </div>
  );
};
